import apiClient from "../plugins/axios";
import { AxiosResponse } from "axios";

/**
 * Fetches children information for MyPageParent.
 *
 * @return {Promise<any>} The response data if status is 200, otherwise null
 */
export async function fetchChildrenInformationForMyPageParent(): Promise<any> {
  const response = await apiClient.get("/users/children");

  if (response && response.status === 200) {
    return response.data;
  }

  return null;
}

export async function fetchActivityLogs(userId: number): Promise<any> {
  const response: AxiosResponse = await apiClient.get(
    `/users/${userId}/activity-logs`
  );

  if (Object.keys(response).length == 0 && response.status !== 200) {
    return null;
  }

  return response.data;
}

export async function fetchSozowCoinCredit(userId: number): Promise<any> {
  const response: AxiosResponse = await apiClient.get(
    `/users/${userId}/coin-credit`
  );

  if (Object.keys(response).length == 0 && response.status !== 200) {
    return null;
  }

  return response.data;
}

export async function fetchSozowCoinSentAndReceivedLogs(
  userId: number
): Promise<any> {
  const response: AxiosResponse = await apiClient.get(
    `/users/${userId}/sozow-coin-logs`
  );

  if (Object.keys(response).length == 0 && response.status !== 200) {
    return null;
  }

  return response.data;
}

export async function fetchNumberOfPostsOnSlack(userId: number): Promise<any> {
  const response: AxiosResponse = await apiClient.get(
    `/users/${userId}/slack/posts/count`
  );

  if (Object.keys(response).length == 0 && response.status !== 200) {
    return null;
  }

  return response.data;
}

export async function fetch30SecondSurveys(userId: number): Promise<any> {
  const response: AxiosResponse = await apiClient.get(
    `/users/${userId}/30-second-surveys`
  );

  if (Object.keys(response).length == 0 && response.status !== 200) {
    return null;
  }

  return response.data;
}
